msgid ""
msgstr ""
"POT-Creation-Date: 2023-08-30 18:51+0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: hy\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/domains/buy-ticket/select-seats.tsx:83
msgid "{remainingSeatCount, plural, =0 {Места выбраны} =1 {Осталось выбрать 1 место} =2 {Осталось выбрать 2 места} =3 {Осталось выбрать 3 места} =4 {Осталось выбрать 4 места} other {}}"
msgstr "{remainingSeatCount, plural, =0 {Seats selected} =1 {1 seat left to select} =2 {2 seats left to select} =3 {3 seats left to select} =4 {4 seats left to select} other {}}"

#: src/components/train-route-info/train-route-info.tsx:31
msgid "Hч mmм"
msgstr "H[h] mm[m]"

#: src/domains/sign-in/sign-in.tsx:47
#: src/domains/sign-up/sign-up.tsx:36
msgid "Авторизация не удалась"
msgstr "Authentication failed"

#: src/domains/buy-ticket/buy-ticket.tsx:227
#: src/domains/buy-ticket/buy-ticket.tsx:228
#: src/domains/buy-ticket/select-payment-type.tsx:10
#: src/domains/buy-ticket/select-payment-type.tsx:10
msgid "Банковской картой"
msgstr "By bank card"

#: src/pages/ticket-details/ticket-details.page.tsx:188
msgid "Билет не найден. Попробуйте обновить страницу или вернуться к списку билетов"
msgstr "Tickets not found. Try to update the page or return to the list of tickets"

#: src/pages/my-tickets/my-tickets.page.tsx:66
msgid "Билеты пока что отсутствуют"
msgstr "No tickets yet"

#: src/pages/sign-up/sign-up.page.tsx:50
msgid "в личном кабинете"
msgstr "in the personal account"

#: src/domains/push-notify/push-notify-settings.tsx:38
msgid "В настройках вашего браузера запрещено показывать уведомления для этого приложения"
msgstr "Your browser settings prohibit showing notifications for this application"

#: src/domains/push-notify/push-notify-settings.tsx:30
msgid "В настройках вашего телефона запрещено показывать уведомления для этого приложения"
msgstr "Your phone settings prohibit showing notifications for this application"

#: src/components/train-route-info/train-route-info.tsx:136
#~ msgid "в пути"
#~ msgstr "on the way"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:108
#~ msgid "В рамках одной покупки можно приобрести только один билет"
#~ msgstr "Only one ticket can be purchased within a single purchase"

#: src/pages/ticket-details/ticket-details.page.tsx:226
#~ msgid "вагон"
#~ msgstr "wagon"

#: src/domains/buy-ticket/select-seats.tsx:149
msgid "Вагон"
msgstr "Carriage"

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:29
msgid "Вагон и место"
msgstr "Car and seat"

#: src/domains/push-notify/push-notify-settings.tsx:26
msgid "Ваше устройство не поддерживает Web Push уведомления"
msgstr "Your device does not support Web Push notifications"

#: src/domains/available-routes/ui/select-stations.tsx:115
msgid "Введите название станции"
msgstr "Enter the station name"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:36
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:43
msgid "Вернуть билет"
msgstr "Refund ticket"

#: src/App.tsx:69
msgid "Версия"
msgstr "Version"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:29
msgid "Вид тарифа"
msgstr "Tariff type"

#: src/domains/push-notify/push-notify-access-request.tsx:58
msgid "Включить уведомления"
msgstr "Enable notifications"

#: src/domains/buy-ticket/agreement.tsx:16
msgid "Внимание!"
msgstr "Attention!"

#: src/domains/sign-in/sign-in.tsx:135
#: src/features/main-side-menu/main-side-menu.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:91
msgid "Войти"
msgstr "Sign in"

#: src/pages/reset-password/reset-password.page.tsx:176
msgid "Войти в личный кабинет"
msgstr "Log in to your account"

#: src/pages/order-status/order-status.page.tsx:328
msgid "Все оплаченные билеты доступны в разделе <0>Мои билеты</0>."
msgstr "All paid tickets are available in the <0>My Tickets</0> section."

#: src/pages/main/main.page.tsx:106
msgid "Вход"
msgstr "Sign in"

#: src/pages/sign-in/sign-in.page.tsx:49
msgid "Вход в личный кабинет"
msgstr "Account entry"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:37
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:46
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:59
msgid "Вы уверены, что хотите отменить заказ?"
msgstr "Are you sure you want to cancel the order?"

#: src/domains/buy-ticket/select-seats.tsx:63
#: src/domains/buy-ticket/select-seats.tsx:68
msgid "Выберите место"
msgstr "Select a seat"

#: src/pages/buy-tickets/buy-tickets.tsx:24
msgid "Выбор мест"
msgstr "Seats selection"

#: src/pages/main/main.page.tsx:112
msgid "Выбор языка"
msgstr "Change language"

#: src/domains/buy-ticket/buy-ticket.tsx:244
msgid "Выбрать место"
msgstr "Select a seat"

#: src/pages/logout/logout.page.tsx:60
msgid "Выполняется выход из приложения..."
msgstr "The application is exiting..."

#: src/domains/buy-ticket/redirect-to-bank.tsx:18
msgid "Выполняется переход на сайт банка для оплаты. Если этого не произошли, нажмите на ссылку"
msgstr "Going to the bank's website for payment. If it doesn't, click on the link"

#: src/features/main-side-menu/main-side-menu.tsx:64
msgid "Выход"
msgstr "Logout"

#: src/domains/buy-ticket/select-seats.tsx:78
msgid "Голова поезда находится в верху экрана"
msgstr "The head of the train is at the top of the screen"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:26
#~ msgid "Гюмри"
#~ msgstr "Gyumri"

#: src/pages/ticket-details/ticket-details.page.tsx:116
#: src/pages/ticket-details/ticket-details.page.tsx:141
#: src/pages/ticket-details/ticket-details.page.tsx:224
msgid "Данные билета"
msgstr "Ticket details"

#: src/pages/order-details/order-details.page.tsx:85
#: src/pages/order-details/order-details.page.tsx:122
#: src/pages/order-details/order-details.page.tsx:169
#: src/pages/order-details/order-details.page.tsx:224
#: src/pages/order-status/order-status.page.tsx:93
#: src/pages/order-status/order-status.page.tsx:118
#: src/pages/order-status/order-status.page.tsx:153
#: src/pages/ticket-details/ticket-details.page.tsx:177
#: src/pages/ticket-details/ticket-details.page.tsx:302
msgid "Данные заказа"
msgstr "Order details"

#: src/domains/buy-ticket/pay-confirm.tsx:23
#: src/pages/order-status/order-status.page.tsx:358
msgid "Дата"
msgstr "Date"

#: src/pages/my-tickets/my-tickets.page.tsx:79
#: src/pages/order-details/order-details.page.tsx:45
#: src/pages/ticket-details/ticket-details.page.tsx:78
msgid "Дата заказа"
msgstr "Order date"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:162
#: src/domains/available-routes/features/available-routes/available-routes.tsx:163
msgid "День отправления"
msgstr "Departure day"

#: src/domains/push-notify/push-notify-access-request.tsx:39
msgid "Для получения уведомлений без запуска приложения требуется ваше разрешение. Обещаем не беспокоить вас по пустякам."
msgstr "Your permission is required to receive notifications without launching the application. We promise not to disturb you unnecessarily."

#: src/pages/order-status/order-status.page.tsx:324
msgid "Для просмотра вашего билета нажмите на кнопку ниже."
msgstr "To view your ticket, click the button below."

#: src/domains/push-notify/push-notify-settings.tsx:19
msgid "Для работы уведомлений необходимо добавить приложение на главный экран через меню на панели браузера"
msgstr "or notifications to work, you need to add the application to your home screen through the browser panel menu"

#: src/pages/buy-tickets/buy-tickets.tsx:22
msgid "Добавление пассажиров"
msgstr "Increase in passengers"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:25
#~ msgid "Ереван"
#~ msgstr "Yerevan"

#: src/pages/order-details/order-details.page.tsx:312
#: src/pages/order-status/order-status.page.tsx:228
msgid "Если у вас не получилось произвести оплату, оплатить заказ можно по ссылке"
msgstr "If you are unable to make a payment, you can pay for the order using the link"

#: src/pages/reset-password/reset-password.page.tsx:186
#: src/pages/sign-in/sign-in.page.tsx:80
msgid "Еще не зарегистрированны?"
msgstr "Not registered yet?"

#: src/domains/shared/refund-fee-express.tsx:41
msgid "За <0>20</0> минут до отправления поезда билет возврату не подлежит."
msgstr "The ticket is non-refundable before <0>20</0> minutes from of train departure."

#: src/pages/my-orders/my-orders.page.tsx:87
msgid "Забронирован"
msgstr "Reserved"

#: src/pages/sign-in/sign-in.page.tsx:62
#: src/pages/sign-up/sign-up.page.tsx:63
msgid "Забыли пароль?"
msgstr "Forgot your password?"

#: src/pages/order-status/order-status.page.tsx:278
msgid "Заказ был забронирован"
msgstr "Order has been booked"

#: src/pages/order-status/order-status.page.tsx:283
msgid "Заказ был забронирован и ожидает завершения оплаты"
msgstr "Order has been booked and is awaiting payment completion"

#: src/pages/order-details/order-details.page.tsx:298
#: src/pages/ticket-details/ticket-details.page.tsx:330
msgid "Заказ был забронирован и ожидает оплаты"
msgstr "The order has been reserved and is awaiting payment"

#: src/pages/order-status/order-status.page.tsx:298
msgid "Заказ был отменен"
msgstr "Order has been canceled"

#: src/pages/ticket-details/ticket-details.page.tsx:338
msgid "Заказ был отменен. Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr "The order has been cancelled. The cost of the paid ticket will be refunded using the selected payment method (Bank card)"

#: src/pages/order-details/order-details.page.tsx:276
#: src/pages/order-status/order-status.page.tsx:303
msgid "Заказ был отменен. Сумма заказа вернется на ваш счет"
msgstr "The order has been cancelled. The amount of the order will be refunded to your account"

#: src/pages/order-status/order-status.page.tsx:319
msgid "Заказ был успешно оплачен"
msgstr "Order has been successfully paid"

#: src/pages/order-details/order-details.page.tsx:180
msgid "Заказ не найден. Попробуйте обновить страницу или вернуться к списку заказов"
msgstr "Order is not found. Please try to update the page or return to the orders list"

#: src/pages/order-status/order-status.page.tsx:218
msgid "Заказ обрабатывается"
msgstr "Order is being processed"

#: src/pages/order-details/order-details.page.tsx:307
#: src/pages/order-status/order-status.page.tsx:223
#: src/pages/ticket-details/ticket-details.page.tsx:382
msgid "Заказ обрабатывается, ожидаем подтверждения оплаты"
msgstr "Order is being processed, payment confirmation is pending"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:66
msgid "Заказ с ошибкой будет скрыт"
msgstr "An order with an error will be hidden"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:59
msgid "Заказы"
msgstr "Orders"

#: src/pages/my-orders/my-orders.page.tsx:142
msgid "Заказы пока что отсутствуют"
msgstr "No orders yet"

#: src/domains/sign-up/sign-up.tsx:173
#: src/pages/reset-password/reset-password.page.tsx:197
#: src/pages/sign-in/sign-in.page.tsx:90
msgid "Зарегистрироваться"
msgstr "Sign Up"

#: src/domains/buy-ticket/buy-ticket.tsx:299
#: src/domains/buy-ticket/buy-ticket.tsx:327
msgid "Изменить данные"
msgstr "Change the data"

#: src/domains/buy-ticket/buy-ticket.tsx:271
msgid "Изменить данные пассажиров"
msgstr "Change passengers data"

#: src/pages/sign-in/sign-in.page.tsx:73
#: src/pages/sign-up/sign-up.page.tsx:74
msgid "Изменить пароль"
msgstr "Change the password"

#: src/features/main-side-menu/main-side-menu.tsx:54
msgid "История заказов"
msgstr "Orders"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:54
msgid "Итого"
msgstr "Total"

#: src/pages/search/seach-routes-loading.tsx:17
msgid "Ищем доступные маршруты..."
msgstr "Looking for available routes"

#: src/domains/push-notify/push-notify-access-request.tsx:32
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для \"pass.railway.am\" или Railway AM"
msgstr "It seems you have prohibited the application from sending you notifications. To receive notifications, go to your phone settings and allow notifications for \"pass.railway.am\" or Railway AM"

#: src/domains/push-notify/push-notify-access-request.tsx:26
msgid "Кажется, Вы запретили приложению присылать вам уведомления. Для получения уведомлений зайдите в настройки телефона и разрешите показывать уведомления для Railway AM"
msgstr "It seems you have prohibited the application from sending you notifications. To receive notifications, go to your phone settings and allow notifications for Railway AM"

#: src/domains/reset-password/change-pass.form.tsx:59
#: src/domains/sign-up/sign-up.tsx:158
msgid "Код подтверждения"
msgstr "Confirmation code"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:118
msgid "Количество пассажиров:"
msgstr "Number of passengers"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:31
#: src/features/main-side-menu/main-side-menu.tsx:33
#: src/pages/logout/logout.page.tsx:49
#~ msgid "личный кабинет"
#~ msgstr "msgstr   Personal account"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:37
#: src/features/main-side-menu/main-side-menu.tsx:36
#: src/pages/logout/logout.page.tsx:49
msgid "Личный кабинет"
msgstr "Personal account"

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:52
#~ msgid "Любое свободное"
#~ msgstr "Any available"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:150
#: src/domains/buy-ticket/pay-confirm.tsx:26
msgid "Маршрут"
msgstr "Route"

#: src/pages/search/search.page.tsx:138
msgid "Маршруты не найдены"
msgstr "Routes are not found"

#: src/domains/buy-ticket/select-seats.tsx:95
msgid "Места выбраны"
msgstr "Seats are selected"

#: src/pages/ticket-details/ticket-details.page.tsx:230
#~ msgid "место"
#~ msgstr "seat"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:50
#: src/features/main-side-menu/main-side-menu.tsx:45
#: src/pages/my-tickets/my-tickets.page.tsx:52
#: src/pages/order-details/order-details.page.tsx:144
#: src/pages/order-details/order-details.page.tsx:289
#: src/pages/order-details/order-details.page.tsx:341
#: src/pages/order-status/order-status.page.tsx:140
#: src/pages/order-status/order-status.page.tsx:200
#: src/pages/order-status/order-status.page.tsx:261
#: src/pages/ticket-details/ticket-details.page.tsx:163
#: src/pages/ticket-details/ticket-details.page.tsx:199
#: src/pages/ticket-details/ticket-details.page.tsx:371
#: src/pages/ticket-details/ticket-details.page.tsx:410
msgid "Мои билеты"
msgstr "My tickets"

#: src/pages/my-orders/my-orders.page.tsx:129
#: src/pages/order-details/order-details.page.tsx:192
msgid "Мои заказы"
msgstr "My orders"

#: src/pages/reset-password/reset-password.page.tsx:134
msgid "Мы отправим код подтверждения на указанный номер телефона"
msgstr "We will send a verification code to the specified phone number"

#: src/pages/reset-password/reset-password.page.tsx:129
msgid "На следующем шаге нужно ввести код подтверждения и новый пароль"
msgstr "The next step is to enter a confirmation code and a new password"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:74
#~ msgid "Название отсутствует"
#~ msgstr "No title"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:28
#~ msgid "Название тарифа"
#~ msgstr "Tariff name"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:171
msgid "Найти билеты"
msgstr "Find tickets"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:81
#: src/domains/push-notify/push-notify.page.tsx:46
msgid "Настройка уведомлений"
msgstr "Notification settings"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:69
msgid "Начальная и конечная станции совпадают"
msgstr "The starting station and the final station are coincide"

#: src/components/tickets-count/tickets-count.tsx:70
msgid "Не найдены билеты с тарифами по выбранному маршруту."
msgstr "No fare tickets are found for the selected route."

#: src/domains/push-notify/use-push-notify-perms.ts:55
#: src/domains/push-notify/use-push-notify-perms.ts:136
msgid "Не получилось создать подписку на уведомления. Попробуйте перезапустить приложение"
msgstr "Failed to create notification subscription. Try restarting the application"

#: src/domains/push-notify/use-push-notify-perms.ts:234
msgid "Не удалось выполнить подписку в приложении"
msgstr "Failed to complete subscription in the application"

#: src/pages/buy-tickets/buy-tickets.tsx:54
msgid "Неверные параметры в строке адреса. Начните поиск билетов заново"
msgstr "Invalid parameters at the address bar"

#: src/components/search-route-card/search-route-card-data.tsx:32
msgid "Нет свободных мест"
msgstr "No seats available"

#: src/domains/reset-password/change-pass.form.tsx:69
msgid "Новый пароль"
msgstr "New password"

#: src/pages/ticket-details/ticket-details.page.tsx:74
msgid "Номер заказа"
msgstr "Order number"

#: src/domains/buy-ticket/pay-confirm.tsx:22
#: src/pages/order-details/order-details.page.tsx:43
#: src/pages/order-status/order-status.page.tsx:354
msgid "Номер платежа"
msgstr "Number of the payment"

#: src/pages/ticket-details/trip-data/trip-data.tsx:23
msgid "Номер рейса"
msgstr "Train number"

#: src/domains/reset-password/change-pass.form.tsx:36
#: src/domains/reset-password/login.form.tsx:25
#: src/domains/sign-in/sign-in.tsx:98
#: src/domains/sign-up/sign-up.tsx:117
msgid "Номер телефона"
msgstr "Phone number"

#: src/pages/order-details/order-details.page.tsx:333
#: src/pages/order-status/order-status.page.tsx:192
#: src/pages/order-status/order-status.page.tsx:253
#: src/pages/ticket-details/ticket-details.page.tsx:362
#: src/pages/ticket-details/ticket-details.page.tsx:401
msgid "Обновить статус"
msgstr "Update status"

#: src/pages/my-orders/my-orders.page.tsx:43
msgid "Ожидает оплаты"
msgstr "Awaiting payment"

#: src/pages/order-status/order-status.page.tsx:263
#~ msgid "Он будет сохранен в разделе \"Мои билеты\""
#~ msgstr "It will be saved in the \"My tickets\" section"

#: src/domains/buy-ticket/pay-confirm.tsx:24
#: src/pages/order-details/order-details.page.tsx:48
#: src/pages/order-status/order-status.page.tsx:361
msgid "Описание"
msgstr "Description"

#: src/domains/buy-ticket/buy-ticket.tsx:291
#: src/domains/buy-ticket/buy-ticket.tsx:319
msgid "Оплатить"
msgstr "Pay"

#: src/pages/my-orders/my-orders.page.tsx:58
msgid "Оплачен"
msgstr "Paid"

#: src/pages/order-details/order-details.page.tsx:55
msgid "Оплачено"
msgstr "Paid"

#: src/domains/feedback/reviews.page.tsx:170
msgid "Оставить отзыв"
msgstr "Leave review"

#: src/domains/buy-ticket/select-seats.tsx:76
#~ msgid "Осталось выбрать {remainingSeatCount} место"
#~ msgstr "{remainingSeatCount} seats left to choose"

#: src/pages/ticket-details/ticket-details.page.tsx:297
msgid "Отзыв о поездке"
msgstr "Trip review"

#: src/domains/cabinet/pages/cabinet.index.page.tsx:68
#: src/domains/feedback/reviews.page.tsx:60
#: src/domains/feedback/reviews.page.tsx:99
msgid "Отзывы"
msgstr "Reviews"

#: src/domains/feedback/grade-title.ts:12
msgid "Отлично"
msgstr "Excellent"

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:75
msgid "Отмена"
msgstr "Cancel"

#: src/domains/cabinet/features/tickets/refund-ticket-button.tsx:49
msgid "Отмена заказа"
msgstr "Order cancellation"

#: src/pages/my-orders/my-orders.page.tsx:101
msgid "Отменен"
msgstr "Canceled"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:73
msgid "Отмененный заказ будет скрыт"
msgstr "Canceled order will be hidden"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:58
msgid "Отменить заказ"
msgstr "Cancel the order"

#: src/domains/reset-password/change-pass.form.tsx:76
#: src/domains/reset-password/login.form.tsx:45
msgid "Отправить код"
msgstr "Send the code"

#: src/domains/feedback/add-feedback-form.tsx:75
msgid "Отправить отзыв"
msgstr "Send review"

#: src/pages/order-details/order-details.page.tsx:82
#: src/pages/order-status/order-status.page.tsx:99
#~ msgid "Отсутсвует ID платежа. Купленные билеты можно посмотреть в разделе \"Мои билеты\""
#~ msgstr "Missing payment ID. Purchased tickets can be viewed in the  \"My tickets\" section"

#: src/pages/order-details/order-details.page.tsx:133
#: src/pages/order-status/order-status.page.tsx:129
#: src/pages/ticket-details/ticket-details.page.tsx:152
msgid "Отсутствует ID платежа. Купленные билеты можно посмотреть в разделе \"Мои билеты\""
msgstr "Payment ID is missing. Purchased tickets can be viewed in the \"My Tickets\" section"

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:90
msgid "Отсутствуют необходимые параметры в адресе страницы. Оцените поездку в приложении"
msgstr "Required parameters are missing in the page address. Rate your trip in the application"

#: src/domains/feedback/reviews.page.tsx:177
msgid "Оцененные поездки"
msgstr "Rated trips"

#: src/pages/push-notify-rate-trip/push-notify-rate-trip.page.tsx:78
#: src/pages/ticket-details/ticket-details.page.tsx:291
msgid "Оцените поездку"
msgstr "Rate the trip"

#: src/domains/feedback/grade-title.ts:7
msgid "Оценка отсутствует"
msgstr "No rating"

#: src/domains/feedback/grade-title.ts:8
msgid "Очень плохо"
msgstr "Very poor"

#: src/pages/main/notification-center.tsx:47
msgid "Очистить все"
msgstr "Clear all"

#: src/pages/my-orders/my-orders.page.tsx:73
msgid "Ошибка"
msgstr "Error"

#: src/pages/order-status/order-status.page.tsx:171
msgid "Ошибка при обработке заказа"
msgstr "Error processing the order"

#: src/domains/push-notify/use-push-notify-perms.ts:144
msgid "Ошибка при подписке на уведомления. Попробуйте позднее"
msgstr "Error while subscribing to notifications. Please try again later"

#: src/domains/sign-in/sign-in.tsx:122
#: src/domains/sign-up/sign-up.tsx:139
msgid "Пароль"
msgstr "Password"

#: src/pages/reset-password/reset-password.page.tsx:160
msgid "Пароль был успешно изменен"
msgstr "Password has been successfully changed"

#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:39
msgid "Пассажир"
msgstr "Passenger"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:109
#: src/pages/ticket-details/ticket-pass/ticket-pass.tsx:25
msgid "Пассажиры"
msgstr "Passengers"

#: src/domains/buy-ticket/redirect-to-bank.tsx:24
#: src/pages/order-status/order-status.page.tsx:234
msgid "Перейти к оплате"
msgstr "Go to the payment"

#: src/domains/buy-ticket/select-seats.tsx:111
msgid "Перейти к оформлению"
msgstr "Go to checkout"

#: src/pages/buy-tickets/buy-tickets.tsx:30
msgid "Переход к банку"
msgstr "Going to the bank"

#: src/domains/feedback/grade-title.ts:9
msgid "Плохо"
msgstr "Poor"

#: src/pages/search/search.page.tsx:142
msgid "Повторить поиск"
msgstr "Repeat the search"

#: src/domains/push-notify/push-notify-settings.tsx:53
msgid "Подписка на уведомления"
msgstr "Notification subscription"

#: src/pages/buy-tickets/buy-tickets.tsx:28
msgid "Подтверждение платежа"
msgstr "Payment confirmation"

#: src/domains/feedback/reviews.page.tsx:131
msgid "Поездки без отзыва"
msgstr "Trips without reviews"

#: src/domains/feedback/reviews.page.tsx:73
#: src/domains/feedback/reviews.page.tsx:113
msgid "Поездки пока что отсутствуют"
msgstr "No trips available yet"

#: src/domains/feedback/add-feedback-form.tsx:40
msgid "Пожалуйста, выберите оценку"
msgstr "Rate your experience"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:68
#: src/domains/available-routes/features/available-routes/available-routes.tsx:74
#: src/domains/reset-password/change-pass.form.tsx:28
#: src/domains/reset-password/change-pass.form.tsx:29
#: src/domains/reset-password/login.form.tsx:18
#: src/domains/sign-in/sign-in.tsx:36
#: src/domains/sign-in/sign-in.tsx:37
#: src/domains/sign-up/sign-up.tsx:97
#: src/domains/sign-up/sign-up.tsx:98
#: src/domains/sign-up/sign-up.tsx:109
msgid "Пожалуйста, заполните поле"
msgstr "Please, fill in the field"

#: src/domains/sign-up/sign-up.tsx:103
msgid "Пожалуйста, проверьте правильность email"
msgstr "Please, check your email"

#: src/features/main-side-menu/main-side-menu.tsx:27
msgid "Поиск билетов"
msgstr "Search of tickets"

#: src/pages/search/search.page.tsx:44
msgid "Поиск маршрутов"
msgstr "Search of the routes"

#: src/components/ticket-qr/ticket-qr.tsx:20
msgid "Покажите QR код проводнику в поезде"
msgstr "Show the QR code to the train conductor"

#: src/pages/order-status/order-status.page.tsx:265
#~ msgid "Покажите его сотруднику ЮКЖД на просьбу предъявить билет"
#~ msgstr "Show a ticket to an employee of the SCR when he asked to show the ticket"

#: src/pages/my-tickets/my-tickets.page.tsx:114
#: src/pages/order-details/order-details.page.tsx:359
#: src/pages/order-status/order-status.page.tsx:344
msgid "Показать билет"
msgstr "Show ticket"

#: src/pages/my-tickets/my-tickets.page.tsx:113
#~ msgid "Показать данные билета"
#~ msgstr "Show ticket data"

#: src/pages/my-orders/my-orders.page.tsx:203
#~ msgid "Показать данные заказа"
#~ msgstr "Show order data"

#: src/pages/my-orders/my-orders.page.tsx:203
msgid "Показать заказ"
msgstr "Show order"

#: src/pages/order-details/order-details.page.tsx:318
#: src/pages/ticket-details/ticket-details.page.tsx:387
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе \"Мои билеты\""
msgstr "Try to update the status or check the purchased tickets in the \"My tickets\" section."

#: src/pages/order-status/order-status.page.tsx:237
msgid "Попробуйте обновить статус, либо проверить купленные билеты в разделе <0>Мои билеты</0>"
msgstr "Try refreshing the status or check purchased tickets in the <0>My Tickets</0> section"

#: src/components/tickets-count/tickets-count.tsx:71
msgid "Попробуйте проверить или выбрать другой маршрут"
msgstr "Try to check or choose another route"

#: src/components/tickets-price/tickets-price.tsx:68
msgid "После оплаты Вам будет доступен QR-код. Покажите его сотруднику ЮКЖД в поезде на просьбу предъявить билет для проверки"
msgstr "After payment, a QR code will be available to you. Show it to the SCR employee on the train when he asked you to present the ticket for verification"

#: src/domains/feedback/reviews.page.tsx:220
msgid "Посмотреть отзыв"
msgstr "View review"

#: src/domains/shared/refund-fee-express.tsx:35
msgid "При возврате билета за <0>1</0> час до отправления поезда от стоимости билета с пассажира удерживается <1>750</1> драм."
msgstr "If the ticket is  returned <0>1</0> hour before the departure of the train, <1>750</1> AMD will be deducted from the ticket price."

#: src/domains/shared/refund-fee-express.tsx:23
msgid "При возврате билета за <0>24</0> часа до отправления поезда от стоимости билета с пассажира удерживается <1>300</1> драм."
msgstr "If the ticket is returned <0>24</0> hours before the departure of the train, <1>300</1> AMD will be deducted from the ticket price."

#: src/domains/shared/refund-fee-express.tsx:29
msgid "При возврате билета за <0>6</0> часов до отправления поезда от стоимости билета с пассажира удерживается <1>500</1> драм."
msgstr "If the ticket is returned <0>6</0> hours before the departure of the train, <1>500</1> AMD will be deducted from the ticket price."

#: src/domains/buy-ticket/agreement.tsx:20
msgid "При возврате группового билета возврату подлежат все места. Возврат отдельного места не производится."
msgstr "Refunds for group tickets apply to all seats. Individual seats cannot be refunded."

#: src/pages/order-details/order-details.page.tsx:267
#: src/pages/order-status/order-status.page.tsx:178
#: src/pages/ticket-details/ticket-details.page.tsx:351
msgid "При обработке платежа произошла ошибка"
msgstr "An error occurred while processing the payment"

#: src/components/search-route-card/search-route-card-data.tsx:34
msgid "Приобрести билеты"
msgstr "Buy tickets"

#: src/domains/buy-ticket/buy-ticket.tsx:235
msgid "Продолжить"
msgstr "Continue"

#: src/pages/buy-tickets/buy-tickets.tsx:32
msgid "Пустой заголовок"
msgstr "Empty title"

#: src/domains/tz-notify/tz-notify.tsx:20
msgid "Расписание движения поездов не изменится."
msgstr "The train schedule will not change."

#: src/pages/main/main.page.tsx:103
#: src/pages/sign-up/sign-up.page.tsx:49
msgid "Регистрация"
msgstr "Sign Up"

#: src/domains/tz-notify/tz-notify.tsx:11
msgid "С 08.10.2023 на сайте будет отображаться <0>местное время <1>(г. Ереван, GMT+4)</1></0> для отправления и прибытия поездов."
msgstr "Starting from 08.10.2023, the website will display <0>local time <1>(Yerevan, GMT+4)</1></0> for train departures and arrivals."

#: src/pages/reset-password/reset-password.page.tsx:120
msgid "Сброс пароля"
msgstr "Reset password"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:65
#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:72
msgid "Скрыть заказ"
msgstr "Hide the order"

#: src/domains/buy-ticket/select-payment-type.tsx:12
msgid "Создать платеж"
msgstr "Create payment"

#: src/components/ui/ui-fullscreen-select/select-search-list.tsx:51
msgid "Станции отсутствуют"
msgstr "Stations are missing"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:153
msgid "Станция назначения"
msgstr "Destination station"

#: src/domains/available-routes/features/available-routes/available-routes.tsx:152
msgid "Станция отправления"
msgstr "Departure station"

#: src/pages/ticket-details/ticket-tariffs/ticket-tariffs.tsx:32
msgid "Стоимость"
msgstr "Price"

#: src/pages/order-details/order-details.page.tsx:51
#: src/pages/order-status/order-status.page.tsx:363
msgid "Стоимость билетов"
msgstr "The cost of tickets"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:47
msgid "Стоимость оплаченного билета будет возвращена с помощью выбранного способа оплаты (банковская карта)"
msgstr "The cost of the paid ticket will be refunded using the selected payment method (Bank card)"

#: src/router/router.tsx:171
msgid "Страница не найдена"
msgstr "Page not found"

#: src/components/tickets-price/tickets-price.tsx:55
msgid "Сумма"
msgstr "Amount"

#: src/pages/my-orders/my-orders.page.tsx:191
msgid "Сумма:"
msgstr "Amount:"

#: src/domains/buy-ticket/add-passengers/passengers-add-control.tsx:175
#: src/pages/ticket-details/ticket-details.page.tsx:286
msgid "Тарифы"
msgstr "Tariffs"

#: src/pages/reset-password/reset-password.page.tsx:163
msgid "Теперь вы можете войти в личный кабинет используя новый пароль"
msgstr "Now you can login to your account using the new password"

#: src/pages/ticket-details/trip-data/trip-data.tsx:30
msgid "Тип состава"
msgstr "Train type"

#: src/domains/feedback/reviews.page.tsx:121
msgid "У вас нет отзывов о поездках или нет поездок, которые можно оценить."
msgstr "You have no trip reviews or no trips that can be rated."

#: src/domains/push-notify/push-notify-access-request.tsx:46
#: src/domains/push-notify/push-notify.page.tsx:34
#: src/domains/push-notify/use-push-notify-perms.ts:233
#: src/pages/main/notification-center.tsx:35
msgid "Уведомления"
msgstr "Notifications"

#: src/domains/feedback/grade-title.ts:10
msgid "Удовлетворительно"
msgstr "Satisfactory"

#: src/pages/sign-up/sign-up.page.tsx:81
msgid "Уже зарегистрированны?"
msgstr "Already registered?"

#: src/pages/buy-tickets/buy-tickets.tsx:26
msgid "Условия возврата"
msgstr "Return Policy"

#: src/domains/feedback/grade-title.ts:11
msgid "Хорошо"
msgstr "Good"

#: src/domains/feedback/add-feedback-form.tsx:54
msgid "Хотите оставить сообщение?"
msgstr "Would you like to leave a message?"

#: src/domains/cabinet/features/tickets/use-ticket-refund.tsx:81
msgid "Что-то пошло не так. Неизвестный статус заказа"
msgstr "Something went wrong. Unknown order status"

#: src/pages/main/main.page.tsx:85
msgid "Электрички Армении"
msgstr "Trains of Armenia"

#: src/pages/order-status/order-status.page.tsx:262
#~ msgid "Это QR-код вашего заказа"
#~ msgstr "This is the QR code of your order"
